import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function SpreadsheetSafety() {
  return <ArticleLayout slug="spreadsheet-safety" />;
}